import * as Throttle from 'promise-parallel-throttle';
import {
  PushNotificationFn,
  RemoveNotificationFn,
} from './NotificationContext';
import { NotificationTypeEnum } from './NotificationTypeEnum';

export const notificationQueue = async <T>(
  queue: (() => Promise<T>)[],
  pushNotification: PushNotificationFn,
  removeNotification: RemoveNotificationFn,
  title: string,
) => {
  if (!queue.length) return [];

  let notificationKey: string;
  notificationKey = pushNotification({
    message: `${title} : 0 / ${queue.length}`,
    type: NotificationTypeEnum.success,
    autoHideDuration: false,
  });

  try {
    return await Throttle.all(queue, {
      maxInProgress: 3,
      progressCallback: ({ amountDone, amountRejected }) => {
        removeNotification(notificationKey);
        notificationKey = pushNotification({
          message: `${title} : ${amountDone} / ${queue.length}${
            amountRejected ? ` (dont ${amountRejected} en echec)` : ''
          }`,
          type: NotificationTypeEnum.success,
          autoHideDuration: amountDone < queue.length ? false : undefined,
        });
      },
    });
  } catch (e) {
    removeNotification(notificationKey);
    throw e;
  }
};
